import { lazy } from "react";

const LessonSchedule = lazy(() => import("@views/Lesson/LessonSchedule"))
const LessonScore = lazy(() => import("@views/Lesson/LessonScore"))
const ExaminationSchedule = lazy(() => import("@views/Lesson/ExaminationSchedule"))
const Lesson = lazy(() => import("@views/Lesson/Lesson"))
const Course = lazy(() => import("@views/Lesson/Lesson/Course"))
const Print = lazy(() => import("@views/Lesson/Lesson/Course/sedevPlan/Print"))
const Information = lazy(() => import("@views/Lesson/Lesson/Course/material/Information"))
const TsahimSurgalt = lazy(() => import("@views/Lesson/Lesson/Course/TsahimSurgalt"))
const Homework = lazy(() => import("@views/Lesson/Lesson/Course/TsahimSurgalt/Homework"))
const PrintScore = lazy(() => import("@views/Lesson/LessonScore/PrintScore"))

const LessonRoutes = [
    {
        path: 'lesson/teach-lesson/',
        element: <Lesson />
    },
    {
        path: 'lesson/lesson-schedule',
        element: <LessonSchedule />
    },
    {
        path: 'lesson/course/:code/',
        element: <Course />
    },
    {
        path: 'lesson/course/print',
        element: <Print />,
        meta: {
            layout: 'blank'
        }
    },
    {
        path: 'lesson/lesson-score',
        element: <LessonScore />
    },
    {
        path: 'lesson/lesson-score/print/',
        element: <PrintScore />,
        meta: {
            layout: 'blank'
        }
    },
    {
        path: 'lesson/examination-schedule',
        element: <ExaminationSchedule />
    },

    {
        path: 'lesson/material-info/:code/',
        element: <Information />
    },
    {
        path: 'lesson/tsahimsurgalt/',
        element: <TsahimSurgalt />,
        meta: {
            layout: 'blank'
        }
    },
    {
        path: 'lesson/tsahimsurgalt/:code/homework/',
        element: <Homework />,
        meta: {
            layout: 'blank'
        }
    },
]

export default LessonRoutes
